<template>
  <BottomNavShared :items="navItems" :active-key="activeKey" />
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import {
    appNavLinks,
    FlowType,
    BottomNav as BottomNavShared,
    type BottomNavItemConfig,
  } from 'freedom-shared';

  import { amplitudeEventsLib } from '@/shared/lib';

  import NavHomeIcon from '@/assets/images/navigation/nav-home.svg?component';
  import NavFavoritesIcon from '@/assets/images/navigation/nav-favorites.svg?component';
  import NavTicketsIcon from '@/assets/images/navigation/nav-tickets.svg?component';
  import NavUserLineIcon from '@/assets/images/navigation/nav-user-line.svg?component';

  const SOURCE_APP_KEY = 'free-cabinet:source-app';

  const { t } = useI18n();
  const router = useRouter();
  const route = useRoute();

  const getSource = () => String(route.name ?? 'unknown');

  const openCabinetWithSource = (...paths: string[]) => {
    sessionStorage.setItem(SOURCE_APP_KEY, FlowType.AVIA);
    appNavLinks.openCabinet(...paths);
  };

  const activeKey = computed(() => {
    if (
      route.name === 'FavoritesPage' ||
      route.name === 'FavoritesDirectionPage'
    ) {
      return 'favorites';
    }
    return 'home';
  });

  const navItems: BottomNavItemConfig[] = [
    {
      key: 'home',
      label: t('bottomNav.home'),
      icon: NavHomeIcon,
      action: () => {
        amplitudeEventsLib.mainTabClicked(getSource());
        router.push({ name: 'MainPage', params: { source: 'tabbar' } });
      },
    },
    {
      key: 'favorites',
      label: t('bottomNav.favorites'),
      icon: NavFavoritesIcon,
      action: () => {
        amplitudeEventsLib.favoritesTabClicked(getSource());
        router.push({ name: 'FavoritesPage', query: { source: 'tabbar' } });
      },
    },
    {
      key: 'tickets',
      label: t('bottomNav.tickets'),
      icon: NavTicketsIcon,
      action: () => {
        amplitudeEventsLib.ordersTabClicked(getSource());
        openCabinetWithSource(FlowType.AVIA, '?tab=orders');
      },
    },
    {
      key: 'cabinet',
      label: t('bottomNav.cabinet'),
      icon: NavUserLineIcon,
      action: () => {
        amplitudeEventsLib.profileTabClicked(getSource());
        openCabinetWithSource('account');
      },
    },
  ];
</script>
